/* Åpne eksterne linker i nytt vindu */
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].relList.add("noreferrer", "noopener");
  }
}

//Collapse order note in cart drawer, remain open if cart note has content
document.addEventListener("DOMContentLoaded", function () {
  var collapsible = document.querySelector(".collaps-cart_notes");
  var span = collapsible.querySelector(".toggle-cartNote");
  var content = collapsible.querySelector(".collaps-cart-note_content");
  var textarea = document.getElementById("CartNoteDrawer");

  // Check if textarea has content
  var hasContent = textarea.value.trim() !== "";

  // Set initial state based on textarea content
  collapsible.classList.toggle("expanded", hasContent);
  content.setAttribute("aria-expanded", hasContent.toString());
  span.innerHTML = hasContent ? "&#10134;" : "&#10133; Legg igjen et notat";

  span.addEventListener("click", function () {
    var isExpanded = collapsible.classList.toggle("expanded");
    content.setAttribute("aria-expanded", isExpanded.toString());
    span.innerHTML = isExpanded ? "&#10134;" : "&#10133; Legg igjen et notat";
  });
});

//Remove one item line from cart drawer with "Fjern" button
async function removeProduct(productId) {
  try {
    const result = await fetch("/cart/change.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: productId,
        quantity: 0,
      }),
    });

    // Update the cart drawer content
    const data = await result.json();
    var cart = new theme.CartDrawer();
    cart.init();
    cart.open();
  } catch (error) {
    console.error("Error removing product:", error);
  }
}

//custom collection grid - Levende produkter template - mobile screen view code
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".custom-collection-grid__item");
  let patternCounter = 0;

  items.forEach((item, index) => {
    item.classList.remove("big"); // Remove the big class to reset any previously set items

    // The pattern is 4 small, 1 big, 2 small, 1 big, then repeat
    if (patternCounter === 4 || patternCounter === 7) {
      item.classList.add("big");
    }

    // Increase the patternCounter and reset it to 0 after 7 items to repeat the pattern
    patternCounter = (patternCounter + 1) % 8;
  });
});

/*  Slå av kommentar for å slå på redirect for kundekonto
// Redirect klassiske kundekontoer login til loyalty family & friends konto
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname === '/account/login') {
    window.location.href = 'https://bogartstore.no/a/loyalty';
  }
});
*/